<template>
  <sec-section>
    <!-- Two columns across the full card from 960px: the offer on the left, what the week
         covers on the right, so no side of the card is left empty. -->
    <sec-panel class="front-door">
      <div class="front-door__grid">
        <div class="front-door__lead">
          <p class="o700 sec-eyebrow">{{ frontDoor.eyebrow }}</p>
          <h2 class="o600 sec-h2">{{ frontDoor.title }}</h2>
          <p class="m600 front-door__strong">
            <v-icon size="22" aria-hidden="true">mdi-calendar-check-outline</v-icon>
            <span>{{ frontDoor.strong }}</span>
          </p>
          <sec-actions :actions="frontDoor.actions" />
        </div>
        <div class="front-door__detail">
          <p v-for="p in frontDoor.paragraphs" :key="p" class="m500 sec-body-lg front-door__text">{{ p }}</p>
        </div>
      </div>
    </sec-panel>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecPanel from '@/components/security/ui/SecPanel.vue';
import SecActions from '@/components/security/ui/SecActions.vue';
import { SERVICES } from '@/content/security/services';

const frontDoor = SERVICES.frontDoor;
</script>

<style scoped>
.sec-panel.front-door {
  border-top: 4px solid var(--sec-accent);
}

.front-door__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sec-s4);
}

.front-door__lead,
.front-door__detail {
  display: flex;
  flex-direction: column;
  gap: var(--sec-s3);
  min-width: 0;
}

.front-door__strong {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 1rem 1.25rem;
  font-size: 1.0625rem;
  line-height: 1.5;
  color: var(--sec-ink);
  background: var(--sec-accent-subtle);
  border-radius: var(--sec-radius-card);
}

.front-door__strong .v-icon {
  flex-shrink: 0;
  margin-top: 1px;
  color: var(--sec-accent-text);
}

.front-door__text {
  color: var(--sec-ink-2);
}

.front-door__text + .front-door__text {
  padding-top: var(--sec-s3);
  border-top: 1px solid var(--sec-line);
}

@media only screen and (min-width: 700px) {
  .sec-panel.front-door {
    padding: 3rem;
  }
}

@media only screen and (min-width: 960px) {
  .front-door__grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 4rem;
  }
  .front-door__detail {
    padding-top: 2.75rem;
  }
}
</style>
